import * as THREE from 'three'
import Experience from '../Experience'

export default class Steeple {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug

    if (this.debug.active) {
    }

    this.resource = this.resources.items.steepleModel
    this.setMaterial()
    this.setModel()
  }
  setMaterial() {
    //Video element:
    this.video = document.getElementById('video')
    this.video.play()

    //videotexture:
    this.videoTexture = new THREE.VideoTexture(this.video)
    this.videoTexture.flipY = false
    this.videoMaterial = new THREE.MeshBasicMaterial({ map: this.videoTexture, side: THREE.FrontSide, toneMapped: false })
    this.videoTexture.needsUpdate = true
    this.videoMaterial.needsUpdate = true
  }

  setModel() {
    this.model = this.resource.scene
    this.model.position.y = -2
    this.scene.add(this.model)

    //TV screen
    const tvScreen = this.model.children.find(child => child.name === 'screen')
    tvScreen.material = this.videoMaterial
  }

  update() {
    this.videoTexture.needsUpdate = true
    this.videoMaterial.needsUpdate = true
  }
}
